var ValueModifierType;
(function (ValueModifierType) {
    ValueModifierType["IDENTITY"] = "concatenate::string::modifier";
    ValueModifierType["CONCATENATE"] = "concatenate::string::modifier";
    ValueModifierType["REPLACEMENTS"] = "replacements::string::modifier";
})(ValueModifierType || (ValueModifierType = {}));
export {};
